import { SearchResultCollection } from '@shared/components/input/search/search-result.interface';
import { AddressType } from '@app/core/types/address-type';

export function mapDarResults(results: any, type: AddressType = 'address'): SearchResultCollection[] {
  let t: string = 'adresse'

  if (type === 'access') {
    t = 'adgangsadresse'
  }
  
  return [{
    category: 'dar.address',
    results: results.map((result: any) => ({
      id: result[t].id,
      title: result.tekst,
    }))
  }]
}
